export const ASSISTANT_CHAT_CONFIG_STORAGE_KEY = "timingChartChatConfig";

export function readAssistantChatConfig(storage) {
    if (!storage || typeof storage.getItem !== "function") return null;
    try {
        const raw = storage.getItem(ASSISTANT_CHAT_CONFIG_STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch (error) {
        console.warn("chat config load failed", error);
        return null;
    }
}

export function writeAssistantChatConfig(storage, config) {
    if (!storage || typeof storage.setItem !== "function") return false;
    try {
        storage.setItem(ASSISTANT_CHAT_CONFIG_STORAGE_KEY, JSON.stringify({
            mode: config?.mode || "st",
            dialect: config?.dialect || "generic-st",
            plcProfileId: config?.plcProfileId || config?.dialect || "generic-st"
        }));
        return true;
    } catch (error) {
        console.warn("chat config save failed", error);
        return false;
    }
}

export function applyAssistantChatConfig(chatState, config) {
    if (!chatState || !config) return chatState;
    chatState.mode = config.mode || chatState.mode;
    chatState.dialect = config.dialect || chatState.dialect;
    chatState.plcProfileId = config.plcProfileId || config.dialect || chatState.plcProfileId || chatState.dialect;
    return chatState;
}
